import { KeyedQuestionnaire, FlattenedQuestionnaire, Field } from '../questionnaireHelpers';

// Turn keyed questionnaire into a flat one, consisting of fields only
export default function flattenQuestionnaire(
	questionnaire: KeyedQuestionnaire
): FlattenedQuestionnaire {
	return questionnaire.reduce((pageAccumulator, currentPage) => {
		return [
			...pageAccumulator,
			...currentPage.blocks.reduce(
				(blockAccumulator, currentBlock) => [...blockAccumulator, ...currentBlock.fields],
				[] as Field[]
			)
		];
	}, [] as Field[]);
}
